var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialLinkedIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7369 9.33456C18.7369 14.4899 14.5576 18.6691 9.4023 18.6691C4.24697 18.6691 0.067749 14.4899 0.067749 9.33456C0.067749 4.17922 4.24697 0 9.4023 0C14.5576 0 18.7369 4.17922 18.7369 9.33456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 5.11888C5 4.79456 5.11342 4.527 5.34025 4.31621C5.56709 4.1054 5.86198 4 6.22491 4C6.58137 4 6.86977 4.10378 7.09013 4.31134C7.31696 4.52539 7.43038 4.80429 7.43038 5.14806C7.43038 5.4594 7.32021 5.71884 7.09985 5.92641C6.87302 6.14046 6.57489 6.24748 6.20547 6.24748H6.19575C5.83929 6.24748 5.55089 6.14046 5.33053 5.92641C5.11017 5.71237 5 5.44318 5 5.11888ZM5.12638 13.632V7.13285H7.28456V13.632H5.12638ZM8.48031 13.632H10.6385V10.003C10.6385 9.77597 10.6644 9.60085 10.7163 9.47761C10.807 9.25708 10.9447 9.0706 11.1294 8.91818C11.3141 8.76575 11.5458 8.68954 11.8245 8.68954C12.5504 8.68954 12.9133 9.17924 12.9133 10.1587V13.632H15.0715V9.9057C15.0715 8.94574 14.8447 8.21767 14.391 7.72147C13.9373 7.22528 13.3378 6.97718 12.5925 6.97718C11.7565 6.97718 11.1051 7.33716 10.6385 8.05713V8.07659H10.6288L10.6385 8.05713V7.13285H8.48031C8.49327 7.3404 8.49975 7.98578 8.49975 9.06898C8.49975 10.1522 8.49327 11.6732 8.48031 13.632Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_15"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.67,
    height: 18.67,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialLinkedIn);
export default __webpack_public_path__ + "static/media/social-linked-in.b93db157ae479c7c03e30f6081cf1b60.svg";
export { ForwardRef as ReactComponent };